import "./App.css";

import { useAuthUser, useIsAuthenticated } from "react-auth-kit";
import { Navigate, Route, Routes } from "react-router-dom";

import { useUnleashContext } from "@unleash/proxy-client-react";
import { useEffect } from "react";
import ContactUs from "./ContactUs";
import Home from "./Home";
import Layout from "./Layout";
import NotFound from "./NotFound";
import Auth from "./auth/Auth";
import AuthLayout from "./auth/AuthLayout";
import EmailVerification from "./auth/EmailVerification";
import Login from "./auth/Login";
import PasswordReset from "./auth/PasswordReset";
import Signup from "./auth/Signup";
import TermsOfUse from "./auth/TermsOfUse";
import { PAGES } from "./constants";
import ProfileOverview from "./profile/Overview";
import Profile from "./profile/Profile";
import ProfileSettings from "./profile/Settings";
import ProfileSubscriptions from "./profile/Subscriptions";

function App() {
  const auth = useAuthUser();
  const updateContext = useUnleashContext();
  const isAuthenticated = useIsAuthenticated();

  //https://github.com/react-auth-kit/react-auth-kit/issues/1023
  const PrivateRoute = ({ Component }) => {
    if (isAuthenticated()) {
      return <Component />;
    } else {
      updateContext({ userId: null });
      return <Navigate to={PAGES.AUTH} />;
    }
  };

  useEffect(() => {
    const auth_data = auth();

    if (isAuthenticated() && "email" in auth_data) {
      updateContext({ userId: auth().email });
    } else {
      updateContext({ userId: null });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Routes>
      <Route path={PAGES.HOME}>
        <Route element={<PrivateRoute Component={Layout} />}>
          <Route index element={<PrivateRoute Component={Home} />} />
          <Route path={PAGES.CONTACT_US} element={<PrivateRoute Component={ContactUs} />} />

          <Route path={PAGES.PROFILE} element={<PrivateRoute Component={Profile} />}>
            <Route index element={<Navigate to={PAGES.PROFILE_OVERVIEW} />} />
            <Route path={PAGES.PROFILE_OVERVIEW} element={<PrivateRoute Component={ProfileOverview} />} />
            <Route path={PAGES.PROFILE_SUBSCRIPTIONS} element={<PrivateRoute Component={ProfileSubscriptions} />} />
            <Route path={PAGES.PROFILE_SETTINGS} element={<PrivateRoute Component={ProfileSettings} />} />
          </Route>
        </Route>

        <Route path={PAGES.AUTH} element={<AuthLayout />}>
          <Route index element={<Auth />} />
          <Route path={PAGES.AUTH_LOGIN} element={<Login />} />
          <Route path={PAGES.AUTH_SIGNUP} element={<Signup />} />
          <Route path={PAGES.AUTH_VERIFICATION} element={<EmailVerification />} />
          <Route path={PAGES.AUTH_PASSWORD_RESET} element={<PasswordReset />} />
          <Route path={PAGES.AUTH_TERMS_OF_USE} element={<TermsOfUse />} />
        </Route>

        <Route path={PAGES.NOT_FOUND} element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
